import Vue from "vue";
import fly from 'flyio';
import qs from 'qs';
import './tips';
Vue.prototype.$http = fly;
//添加请求拦截器
Vue.prototype.$http.interceptors.request.use((request) => {
    if(request.method == "POST"){
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        request.body = qs.stringify(request.body);
        console.log(request);
    } else if(request.method == "GET"){
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        request.body = qs.stringify(request.body);
        console.log(request);
    }
    return request;
})

//添加响应拦截器，响应拦截器会在then/catch处理之前执行
Vue.prototype.$http.interceptors.response.use(
    (response) => {
        //只将请求结果的data字段返回
        return response.data
    },
    (err) => {
        if (err && err.response) {
            switch (err.response.status) {
                case 400: err.message = '请求错误(400)' ; break;
                case 401: 
                err.message = '未授权，请重新登录(401)';
                window.location.href = '/';
                break;
                case 403: err.message = '拒绝访问(403)'; break;
                case 404: err.message = '请求出错(404)'; break;
                case 408: err.message = '请求超时(408)'; break;
                case 500: err.message = '服务器错误(500)';window.location.href = '/'; break;
                case 501: err.message = '服务未实现(501)'; break;
                case 502: err.message = '网络错误(502)'; break;
                case 503: err.message = '服务不可用(503)'; break;
                case 504: err.message = '网络超时(504)'; break;
                case 505: err.message = 'HTTP版本不受支持(505)'; break;
                default: err.message = `连接出错(${err.response.status})!`;

                
            }
        }else{
            err.message = '连接服务器失败!'
        }
        Vue.prototype.$flyio_toast({
            msg:err.message,
            time:1500
        })
     //  console.log(err.message);
        //发生网络错误后会走到这里
        //return Promise.resolve("ssss")
    }
)


// WEBPACK FOOTER //
// ./src/AppConfigH5/flyio.js